import cx from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import mediaQueryResolver, { SCREEN_SIZE, WithMediaQueryResolverProps } from '../../utils/hocs/media-query-resolver';
//@ts-ignore js-file
import Button2 from '../button2/button2';

import './return-button.scss';

type Props = {
    mix?: string;
    screenSize: SCREEN_SIZE;
    isFullButton?: boolean;
    buttonName?: React.ReactNode;
    onClick: () => void;
} & WithMediaQueryResolverProps;

const ReturnButton = (props: Props) => {
    // убираем buttonName из buttonProps, а то он на button ставится как некорректный атрибут
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { mix, screenSize, isFullButton, buttonName: _, ...buttonProps } = props;
    let buttonSize;

    if (isFullButton) {
        buttonSize = Button2.SIZES.M;
    } else {
        buttonSize = screenSize !== SCREEN_SIZE.SMALL ? Button2.SIZES.M : Button2.SIZES.S;
    }
    const buttonMix = cx('return-button', mix);

    /* eslint-disable max-len */
    const arrow = (
        <svg fill="none" height="16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path
                clipRule="evenodd"
                d="M6.71076 3.90955C7.10252 3.51812 7.10119 2.88256 6.70818 2.49238C6.31723 2.10424 5.68563 2.10504 5.29605 2.49456L0.497014 7.29294C0.106464 7.68343 0.106464 8.31655 0.497014 8.70705L5.29605 13.5054C5.68563 13.8949 6.31726 13.8957 6.70822 13.5076C7.1012 13.1174 7.10259 12.4819 6.71088 12.0904L5.29723 10.6777C4.76555 10.1464 4.17564 9.6767 3.5387 9.27754L2.79117 8.80908L2.83776 8.76249L3.79706 8.89952C4.26543 8.96642 4.73796 8.99999 5.21108 8.99999H15.0021C15.5544 8.99999 16.0021 8.55228 16.0021 7.99999C16.0021 7.44771 15.5544 6.99999 15.0021 6.99999H5.21108C4.73796 6.99999 4.26543 7.03357 3.79706 7.10047L2.83777 7.23749L2.79089 7.19063L3.54146 6.72002C4.17744 6.32127 4.76648 5.85219 5.29747 5.32165L6.71076 3.90955Z"
                fill="#201E1E"
                fillRule="evenodd"
            />
        </svg>
    );
    /* eslint-enable max-len */

    const intl = useIntl();

    return (
        <Button2
            aria-label={intl.formatMessage({ id: 'a11y.returnButton' })}
            mix={buttonMix}
            size={buttonSize}
            theme={Button2.THEMES.LESSON}
            {...buttonProps}
        >
            <div className="return-button-item">{arrow}</div>
        </Button2>
    );
};

export default mediaQueryResolver<Props>()(ReturnButton);
